import script from "./InformMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./InformMessage.vue?vue&type=script&setup=true&lang=js"

import "./InformMessage.vue?vue&type=style&index=0&id=0c71fb2a&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c71fb2a"]])

export default __exports__